<template>
  <div>
    <div v-if="posts.length !== 0">
      <div v-for="(post, i) in posts" :key="`post-${i}`">
        <gg-card :class="post.staff ? 'reply-admin reply-margin' : 'reply-margin'">
          <gg-card-title class="app-card-title pt-0 pb-1">
            <v-row class="px-4">
              <v-col cols="12" sm="6">
                <h3 class="mr-2 pt-4 pb-1 d-inline-block">
                  {{ post.account }}
                  <v-chip
                    v-if="post.staff == 1"
                    small
                    dark
                    class="admin-chip mb-1"
                    color="primary"
                  >
                    Staff Member
                  </v-chip>
                </h3>
              </v-col>
              <v-col class="text-left text-sm-right" cols="12" sm="6">
              <span class="body-2">
                {{ post.date }}
              </span>
              </v-col>
            </v-row>
          </gg-card-title>
          <v-card-text class="post-white-space pt-0">
            {{ post.text }}
          </v-card-text>
        </gg-card>
      </div>
    </div>
    <gg-card v-else>
      <gg-card-header>
        Replies
      </gg-card-header>
      <gg-card-text>
        <p>Your Cancellation Request has not been updated yet. Our Cancellations Team will update you as soon as possible.</p>
        <p>You will receive an email notification once your request has been updated. If you would like to provide more information, you may respond via the reply box at the top-right.</p>
        <p>Thank you for your patience.</p>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Posts',
  props: {
    posts: {
      type: Array,
      required: true,
      default: () => ([])
    },
  },
  methods: {
    ...mapActions(['reportError']),
  }
}
</script>

<style lang="scss" scoped>
  .reply-admin {
    .app-card {
      background: #F0FFF0;
    }
    .admin-chip {
      margin: 0 0 10px 0;
    }
  }

  .reply-email {
    text-transform: lowercase;
  }

  .reply-margin {
    margin-top: 30px;
  }

  .post-white-space {
    white-space: pre-line;
  }
</style>
